// extracted by mini-css-extract-plugin
export default {"meal":"CryptoItem_meal__wHCqN","description":"CryptoItem_description__zHnga","price":"CryptoItem_price__t7+bW","name":"CryptoItem_name__qIMOH"};